<template>
  <div class="mt-8 grid grid-cols-1 gap-y-8">
    <data-table
      title="% Cajas rechazadas por proveedor (Semanal)"
      :headers="['Proveedor', ...weeks.map(week => `Sem. ${week}`), 'Total']"
      :rows="
        reorder_rejected_series.map(item => ({
          values: [item.name, ...item.percentages],
          main: false
        }))
      "
    />

    <data-table
      title="Cajas Rechazadas por cada 100 exportadas (Semanal)"
      :headers="['Proveedor', ...weeks.map(week => `Sem. ${week}`), 'Total']"
      :rows="
        reorder_rejected_series.map(item => ({
          values: [item.name, ...item.percentage_rejected_exported],
          main: false
        }))
      "
    />

    <data-table
      title="Cajas rechazadas/cosechadas por proveedor (Semanal)"
      :headers="['Proveedor', ...weeks.map(week => `Sem. ${week}`), 'Total']"
      :rows="rejected_by_harvested"
    />

    <data-table
      title="Distribución de defectos por proveedor"
      :headers="[
        'Defecto',
        ...providers.slice(1).map(provider => provider.name),
        'Total'
      ]"
      :rows="
        reorder_defect_series.map(item => ({
          values: [
            item.name,
            ...item.data,
            item.data.reduce((acc, val) => acc + val, 0)
          ],
          main: false
        }))
      "
    />
  </div>
</template>

<script>
import DataTable from "@/components/views/agro_exporter/quality_reports/container_provider/show_process/DataTable.vue";
export default {
  name: "QualityReportsContainerProviderShowProcessData",
  components: {
    DataTable
  },
  props: {
    rejected_series: {
      type: Array,
      required: true
    },
    defect_series: {
      type: Array,
      required: true
    },
    defects: {
      type: Array,
      required: true
    },
    weeks: {
      type: Array,
      required: true
    },
    providers: {
      type: Array
    }
  },
  computed: {
    reorder_rejected_series() {
      if (this.rejected_series.length == 0) return;

      let new_rejected_series = [...this.rejected_series];
      let firstElement = new_rejected_series.shift();
      firstElement.name = "Total";
      new_rejected_series.push(firstElement);
      return new_rejected_series;
    },

    rejected_by_harvested() {
      return this.reorder_rejected_series.map(item => ({
        values: [
          item.name,
          ...this.weeks.map((_, index) => {
            return `${this.getFormatNumber(
              item.rejected[index]
            )} / ${this.getFormatNumber(item.harvested[index])}`;
          }),
          `${this.getFormatNumber(
            item.rejected[item.rejected.length - 1]
          )} / ${this.getFormatNumber(
            item.harvested[item.harvested.length - 1]
          )}`
        ]
      }));
    },

    reorder_defect_series() {
      let new_defect_series = [...this.defect_series];

      return new_defect_series.map(item => {
        return {
          name: item.name,
          data: item.data.slice(1)
        };
      });
    }
  }
};
</script>
